import { useStore } from '@/store/store';
import { useEffect } from 'react';

export const useHeaderVisible = () => {
    const headerVisible = useStore((s) => s.header.headerVisible);
    const ribbonVisible = useStore((s) => s.header.ribbonVisible);

    useEffect(() => {
        if (headerVisible) {
            document.body.classList.remove('header-hidden');
        } else {
            document.body.classList.add('header-hidden');
        }

        if (ribbonVisible) {
            document.body.classList.remove('ribbon-hidden');
        } else {
            document.body.classList.add('ribbon-hidden');
        }

        return () => {
            document.body.classList.remove('header-hidden', 'ribbon-hidden');
        };
    }, [headerVisible, ribbonVisible]);
};
